import { useEffect, useRef, useState, VFC } from 'react'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { _messagebuttonbg } from 'src/styles/colors'
import styled, { css } from 'styled-components'

type ImageViewerProps = {
  images: string[]
  initialImage: string
}
const ImageViewer: VFC<ModalProps<ImageViewerProps>> = ({
  images,
  initialImage,
}) => {
  const [index, setIndex] = useState(
    images.findIndex((image) => image === initialImage) || 0,
  )
  const selectedImgEl = useRef<HTMLImageElement>(null)
  useEffect(() => {
    if (selectedImgEl.current) selectedImgEl.current.scrollIntoView()
  }, [selectedImgEl.current])
  return (
    <Layout>
      <img src={images[index]} alt="" />
      <div>
        {images.map((image, idx) => (
          <button key={image} onClick={() => setIndex(idx)}>
            <ImgThumbnail
              ref={idx === index ? selectedImgEl : undefined}
              $isSelected={idx === index}
              src={image}
              alt=""
            />
          </button>
        ))}
      </div>
    </Layout>
  )
}
export const ImageViewerModal = asModal(ImageViewer)

const Layout = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  max-width: 50vw;
  > img {
    max-height: 55vh;
    object-fit: scale-down;
  }
  > div {
    display: flex;
    margin-top: 48px;
    overflow-x: auto;
    button {
      display: block;
    }
    img {
      width: 180px;
      object-fit: cover;
      margin: 0 32px;
    }
  }
`
const ImgThumbnail = styled.img<{ $isSelected: boolean }>`
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      border: 2px solid ${_messagebuttonbg};
    `}
`
